/**
 * Format role for user-friendly display
 */
export function formatRole(role: string | undefined | null): string {
  if (!role) return 'User'
  
  const roleMap: Record<string, string> = {
    'VENDOR_ADMIN': 'Vendor Admin',
    'VENDOR': 'Vendor',
    'SUPER_ADMIN': 'Super Admin',
    'ADMIN': 'Admin',
    'CUSTOMER': 'Customer',
    'vendor_admin': 'Vendor Admin',
    'vendor': 'Vendor',
    'super_admin': 'Super Admin',
    'admin': 'Admin',
    'customer': 'Customer',
  }
  
  // Check exact match first
  if (roleMap[role]) {
    return roleMap[role]
  }
  
  // Check case-insensitive match
  const upperRole = role.toUpperCase()
  if (roleMap[upperRole]) {
    return roleMap[upperRole]
  }
  
  // Fallback: convert snake_case or UPPER_SNAKE_CASE to Title Case
  return role
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

